/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiBulkUpdateExpenseVatAmountOverrideRequest,
  ApiLinkFileToExpenseRequest,
  ApiUpdateExpenseAmountEditModeRequest,
  ApiUpdateExpenseSelectedColumnsRequest,
  ApiUploadExpenseFileRequest,
  BulkExportAuditTrailRequestDto,
  BulkUpdateExpensesPayload,
  CreateSplitParams,
  ExpenseCardTransactionAllowedActions,
  ExpenseExtDto,
  ExpenseInsightsDto,
  ExpenseInvoiceAllowedActions,
  ExpenseReimbursementAllowedActions,
  ExpenseSearchAllowedActionsResponse,
  ExpenseSearchCountResponse,
  ExpenseSearchSummaryResponse,
  ExpenseStatusUpdateRequest,
  FileDescriptor,
  GetAllowedActions1Payload,
  GetFiles1Params,
  GetIdsPayload,
  GetListPayload,
  GetSummary1Payload,
  HospitalityCsvDownloadRequest,
  HospitalityExpenseUpdateRequest,
  PagedItemsFileDescriptor,
  PagedResponseExpenseExtDto,
  RequestSplitAsyncParams,
  SplitAutomationResponseDto,
  SplitAutomationStatusResponseDto,
  UpdateRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ExpensesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags expenses-controller
   * @name UpdateExpenseSelectedColumns
   * @request PUT:/api/v1/expense/{expenseId}/selected-columns
   */
  updateExpenseSelectedColumns = (
    expenseId: string,
    data: ApiUpdateExpenseSelectedColumnsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseExtDto, any>({
      path: `/v1/expense/${expenseId}/selected-columns`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateExpenseSelectedColumnsPath = '/v1/expense/${expenseId}/selected-columns'
  static updateExpenseSelectedColumnsMethod = 'PUT'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name UpdateExpenseAmountEditMode
   * @request PUT:/api/v1/expense/{expenseId}/amount-edit-mode
   */
  updateExpenseAmountEditMode = (
    expenseId: string,
    data: ApiUpdateExpenseAmountEditModeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseExtDto, any>({
      path: `/v1/expense/${expenseId}/amount-edit-mode`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateExpenseAmountEditModePath = '/v1/expense/${expenseId}/amount-edit-mode'
  static updateExpenseAmountEditModeMethod = 'PUT'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name BulkUpdateExpenseVatAmountOverride
   * @request PUT:/api/v1/expense/vat-amount-override
   */
  bulkUpdateExpenseVatAmountOverride = (
    data: ApiBulkUpdateExpenseVatAmountOverrideRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseExtDto[], any>({
      path: `/v1/expense/vat-amount-override`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateExpenseVatAmountOverridePath = '/v1/expense/vat-amount-override'
  static bulkUpdateExpenseVatAmountOverrideMethod = 'PUT'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name RequestSplitAsync
   * @request POST:/api/v1/expense/{expenseId}/split-automation/request-split
   * @deprecated
   */
  requestSplitAsync = (
    { expenseId, ...query }: RequestSplitAsyncParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitAutomationResponseDto, any>({
      path: `/v1/expense/${expenseId}/split-automation/request-split`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    })

  static requestSplitAsyncPath = '/v1/expense/${expenseId}/split-automation/request-split'
  static requestSplitAsyncMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name CreateSplit
   * @request POST:/api/v1/expense/{expenseId}/split-automation/create-split
   */
  createSplit = ({ expenseId, ...query }: CreateSplitParams, params: RequestParams = {}) =>
    this.http.request<SplitAutomationStatusResponseDto, any>({
      path: `/v1/expense/${expenseId}/split-automation/create-split`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    })

  static createSplitPath = '/v1/expense/${expenseId}/split-automation/create-split'
  static createSplitMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetFiles1
   * @request GET:/api/v1/expense/{expenseId}/files
   */
  getFiles = ({ expenseId, ...query }: GetFiles1Params, params: RequestParams = {}) =>
    this.http.request<PagedItemsFileDescriptor, any>({
      path: `/v1/expense/${expenseId}/files`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getFilesPath = '/v1/expense/${expenseId}/files'
  static getFilesMethod = 'GET'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name UploadFile2
   * @request POST:/api/v1/expense/{expenseId}/files
   */
  uploadFile = (expenseId: string, data: ApiUploadExpenseFileRequest, params: RequestParams = {}) =>
    this.http.request<FileDescriptor, any>({
      path: `/v1/expense/${expenseId}/files`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadFilePath = '/v1/expense/${expenseId}/files'
  static uploadFileMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name LinkFile
   * @request POST:/api/v1/expense/{expenseId}/files/link
   */
  linkFile = (expenseId: string, data: ApiLinkFileToExpenseRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expense/${expenseId}/files/link`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static linkFilePath = '/v1/expense/${expenseId}/files/link'
  static linkFileMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetSummary1
   * @request POST:/api/v1/expense/summary
   */
  getSummary = (data: GetSummary1Payload, params: RequestParams = {}) =>
    this.http.request<ExpenseSearchSummaryResponse, any>({
      path: `/v1/expense/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSummaryPath = '/v1/expense/summary'
  static getSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name UpdateStatus
   * @request POST:/api/v1/expense/status-update
   */
  updateStatus = (data: ExpenseStatusUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expense/status-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateStatusPath = '/v1/expense/status-update'
  static updateStatusMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetList
   * @request POST:/api/v1/expense/list
   */
  getList = (data: GetListPayload, params: RequestParams = {}) =>
    this.http.request<PagedResponseExpenseExtDto, any>({
      path: `/v1/expense/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getListPath = '/v1/expense/list'
  static getListMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetIds
   * @request POST:/api/v1/expense/ids
   */
  getIds = (data: GetIdsPayload, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/expense/ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getIdsPath = '/v1/expense/ids'
  static getIdsMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name DownloadHospitalityCsv
   * @request POST:/api/v1/expense/download/hospitality-csv
   */
  downloadHospitalityCsv = (data: HospitalityCsvDownloadRequest, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/expense/download/hospitality-csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static downloadHospitalityCsvPath = '/v1/expense/download/hospitality-csv'
  static downloadHospitalityCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name BulkUpdateExpenses
   * @request POST:/api/v1/expense/bulk-update
   */
  bulkUpdateExpenses = (data: BulkUpdateExpensesPayload, params: RequestParams = {}) =>
    this.http.request<ExpenseExtDto[], any>({
      path: `/v1/expense/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateExpensesPath = '/v1/expense/bulk-update'
  static bulkUpdateExpensesMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name BulkExportAuditTrailPdf
   * @request POST:/api/v1/expense/bulk-export-audit-trail/pdf
   * @deprecated
   */
  bulkExportAuditTrailPdf = (data: BulkExportAuditTrailRequestDto, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/v1/expense/bulk-export-audit-trail/pdf`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkExportAuditTrailPdfPath = '/v1/expense/bulk-export-audit-trail/pdf'
  static bulkExportAuditTrailPdfMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetAllowedActions1
   * @request POST:/api/v1/expense/allowed-actions
   */
  getAllowedActions = (data: GetAllowedActions1Payload, params: RequestParams = {}) =>
    this.http.request<
      | ExpenseSearchAllowedActionsResponse
      | ExpenseCardTransactionAllowedActions
      | ExpenseInvoiceAllowedActions
      | ExpenseReimbursementAllowedActions,
      any
    >({
      path: `/v1/expense/allowed-actions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllowedActionsPath = '/v1/expense/allowed-actions'
  static getAllowedActionsMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name UpdateHospitality
   * @request PATCH:/api/v1/expense/{expenseId}/hospitality
   */
  updateHospitality = (
    expenseId: string,
    data: HospitalityExpenseUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseExtDto, any>({
      path: `/v1/expense/${expenseId}/hospitality`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateHospitalityPath = '/v1/expense/${expenseId}/hospitality'
  static updateHospitalityMethod = 'PATCH'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name DeleteFile1
   * @request DELETE:/api/v1/expense/{expenseId}/files/{fileId}
   */
  deleteFile = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expense/${expenseId}/files/${fileId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteFilePath = '/v1/expense/${expenseId}/files/${fileId}'
  static deleteFileMethod = 'DELETE'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name UpdateFile1
   * @request PATCH:/api/v1/expense/{expenseId}/files/{fileId}
   */
  updateFile = (
    expenseId: string,
    fileId: string,
    data: UpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<FileDescriptor, any>({
      path: `/v1/expense/${expenseId}/files/${fileId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateFilePath = '/v1/expense/${expenseId}/files/${fileId}'
  static updateFileMethod = 'PATCH'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetCount1
   * @request GET:/api/v1/expense/{expenseType}/count
   */
  getCount = (
    expenseType:
      | 'CARD_TRANSACTION'
      | 'CARD_TRANSACTION_LINE'
      | 'INVOICE'
      | 'INVOICE_LINE'
      | 'REIMBURSEMENT'
      | 'MILEAGE_LINE'
      | 'PER_DIEM_LINE'
      | 'REIMBURSEMENT_INVOICE_LINE'
      | 'REIMBURSEMENT_INVOICE_LINE_SPLIT'
      | 'FX_FEE'
      | 'PAYMENT_FEE'
      | 'DEFERRED_COST_RELEASE_ITEM'
      | 'unknown_default_open_api',
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseSearchCountResponse, any>({
      path: `/v1/expense/${expenseType}/count`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCountPath = '/v1/expense/${expenseType}/count'
  static getCountMethod = 'GET'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetStatus
   * @request GET:/api/v1/expense/{expenseId}/split-automation/split-status/{requestId}
   */
  getStatus = (expenseId: string, requestId: string, params: RequestParams = {}) =>
    this.http.request<SplitAutomationStatusResponseDto, any>({
      path: `/v1/expense/${expenseId}/split-automation/split-status/${requestId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getStatusPath = '/v1/expense/${expenseId}/split-automation/split-status/${requestId}'
  static getStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetInsights
   * @request GET:/api/v1/expense/{expenseId}/insights
   */
  getInsights = (expenseId: string, params: RequestParams = {}) =>
    this.http.request<ExpenseInsightsDto, any>({
      path: `/v1/expense/${expenseId}/insights`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInsightsPath = '/v1/expense/${expenseId}/insights'
  static getInsightsMethod = 'GET'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name DownloadFile4
   * @request GET:/api/v1/expense/{expenseId}/files/{fileId}/download
   */
  downloadFile = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/v1/expense/${expenseId}/files/${fileId}/download`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static downloadFilePath = '/v1/expense/${expenseId}/files/${fileId}/download'
  static downloadFileMethod = 'GET'
}
